const CallToActionSchema = {
  title: 'Call to Action',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'image',
        'title',
        'text',
        'buttonText',
        'link',
      ],
    },
  ],
  properties: {
    image: {
      title: 'Image',
      type: 'string',
      widget: 'image',
    },
    title: {
      title: 'Title',
      type: 'string',
    },
    text: {
      title: 'Text',
      type: 'string',
      widget: 'textarea',
    },
    buttonText: {
      title: 'Button Text',
      type: 'string',
    },
    link: {
      title: 'Link',
      widget: 'object_browser',
      mode: 'link',
      selectableTypes: ['Document'],
    }
  },
  required: [
        'image',
        'title',
        'text',
        'buttonText',
        'link',
  ],
};

export default CallToActionSchema;